import React from 'react';
import Spacing from '../../portico/spacing/spacing';
import useApplicantInfoStyles from './applicant-info.styles';
import Typography from '@material-ui/core/Typography';
import STATIC_TEXT from '../../../content/common.json';
import { Checkbox } from '@material-ui/core';


interface AcknowledgeTermsProps {
    children?: any;
    readTerms: boolean;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
  }

export const AcknowledgeTerms: React.FC<AcknowledgeTermsProps> = ({ children, ...props }) => {

    const {
        readTerms,
        onChange,
      } = props;

    const { fontBold } = useApplicantInfoStyles();

    return (
        <>
            <Spacing variable="spacing-base-x4" />
            <Typography variant="h2" className={fontBold}>{STATIC_TEXT.welcome.applicationInfo.dataPrivacyConsentTitle}</Typography>
            <Spacing variable="spacing-base-x2" />
            <div className="checkbox__wrapper">
                <label htmlFor="checkbox">
                    <span className="checkbox">
                        <Checkbox
                            checked={readTerms}
                            color="primary"
                            onChange={onChange}
                            data-testid="acknowledge-terms"
                        />
                    </span>
                    <span className="label">
                        {STATIC_TEXT.welcome.applicationInfo.dataPrivacyConsentContent1}
                        <a href="https://www.svb.com/terms-use" target="_blank" rel="noopener noreferrer">{STATIC_TEXT.welcome.applicationInfo.dataPrivacyConsentContent2}</a>
                        {STATIC_TEXT.welcome.applicationInfo.dataPrivacyConsentContent3}
                        <a href="https://www.svb.com/privacy-notice" target="_blank" rel="noopener noreferrer">{STATIC_TEXT.welcome.applicationInfo.dataPrivacyConsentContent4}</a>
                        {STATIC_TEXT.welcome.applicationInfo.dataPrivacyConsentContent5}
                    </span>
                </label>
            </div>
        </>
    );
};
